import { Card, Table } from "antd";
import { Fragment, useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";

import dayjs from "dayjs";
import { CSVLink } from "react-csv";
import {
  awardApi,
  useGetAwardQuery,
} from "../../redux/rtk/features/award/awardApi";
import ViewBtn from "../Buttons/ViewBtn";
import CommonDelete from "../CommonUi/CommonDelete";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";
import AwardEditPopup from "../UI/PopUp/AwardEditPopup";
import BtnLoader from "../loader/BtnLoader";
import Loader from "../loader/loader";
import PageTitle from "../page-header/PageHeader";

//PopUp

const CustomTable = ({ list }) => {
  const [columnsToShow, setColumnsToShow] = useState([]);

  const columns = [
    {
      id: 1,
      title: "ID",
      dataIndex: "id",
      key: "id",
    },

    {
      id: 2,
      title: " Name",
      key: "user",
      dataIndex: "user",
      render: (user) => user?.firstName + " " + user?.lastName,
    },

    {
      id: 6,
      title: "Awarded Date",
      dataIndex: "awardedDate",
      key: "awardedDate",
      render: (awardedDate) => dayjs(awardedDate).format("DD/MM/YYYY"),
    },

    {
      id: 5,
      title: "Comment",
      dataIndex: "comment",
      key: "comment",
    },

    {
      id: 4,
      title: "Action",
      dataIndex: "id",
      key: "action",
      render: (id) => (
        <UserPrivateComponent permission={"readSingle-user"}>
          <ViewBtn path={`/admin/hr/staffs/${id}/`} />
        </UserPrivateComponent>
      ),
    },
  ];

  useEffect(() => {
    setColumnsToShow(columns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columnsToShowHandler = (val) => {
    setColumnsToShow(val);
  };

  const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));

  return (
    <div>
      <div className='text-center my-2 flex justify-between'>
        <h5 className='award-list-title text-color-2 text-xl mb-2'>
          Employee List
        </h5>

        {list && (
          <div>
            <CsvLinkBtn>
              <CSVLink data={list} filename='user_award'>
                Download CSV
              </CSVLink>
            </CsvLinkBtn>
          </div>
        )}
      </div>
      {list && (
        <div style={{ marginBottom: "30px" }}>
          <ColVisibilityDropdown
            options={columns}
            columns={columns}
            columnsToShowHandler={columnsToShowHandler}
          />
        </div>
      )}
      <Table
        loading={!list}
        columns={columnsToShow}
        dataSource={addKeys(list)}
        pagination={{ pageSize: 5 }}
        scroll={{ x: 720 }}
      />
    </div>
  );
};

const DetailAward = () => {
  const { id } = useParams();
  const { data: award } = useGetAwardQuery(id);

  const isLogged = Boolean(localStorage.getItem("isLogged"));

  if (!isLogged) {
    return <Navigate to={"/admin/auth/login"} replace={true} />;
  }

  return (
    <div>
      <PageTitle title=' Back  ' />

      <UserPrivateComponent permission={"readSingle-award"}>
        <Card className='mr-top mt-5'>
          {award ? (
            <Fragment key={award.id}>
              <div>
                <div className='flex justify-between '>
                  <h3 className={"text-xl"}>
                    ID : {award.id} | {award.name}
                  </h3>
                  <div className='flex justify-end'>
                    <AwardEditPopup data={award} />
                    {award ? (
                      <CommonDelete
                        id={id}
                        permission={"delete-award"}
                        deleteThunk={awardApi.endpoints.deleteAward.initiate}
                        navigatePath={-1}
                      />
                    ) : (
                      <BtnLoader />
                    )}
                  </div>
                </div>
                <CustomTable list={award?.awardHistory} />
              </div>
            </Fragment>
          ) : (
            <Loader />
          )}
        </Card>
      </UserPrivateComponent>
    </div>
  );
};

export default DetailAward;
